module.exports = __webpack_public_path__ + "static/img/audit_bg.e9c748d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audit_bg.png
// module id = ZiwH
// module chunks = 1